var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-service',{attrs:{"results":_vm.studentServices,"on-select-navigate":_vm.onSelectNavigateHandler},on:{"search":_vm.onSearchHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }